import React from 'react';
import queryString from 'query-string';
import LoginForm from './LoginForm';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';

const Login = ({ location, translate }) => {

  const api = new ServiceApi()
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type) {
      return false;
    }
    return true;
  }

  document.body.className = 'reelunet-oauth-body';
  document.title = 'ReeluNet';

  return (
    <div className="reelunet-oauth">
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
            translate={translate}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
    </div>
  );
}

export default Login;
